import { render, staticRenderFns } from "./AnswerForm.vue?vue&type=template&id=c9e34922&scoped=true&"
import script from "./AnswerForm.vue?vue&type=script&lang=ts&"
export * from "./AnswerForm.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerForm.vue?vue&type=style&index=0&id=c9e34922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e34922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VRadio,VRadioGroup,VRow,VSimpleTable})
